module.exports = __webpack_public_path__ + "static/img/pantos.ec68c3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/pantos.jpg
// module id = ACg3
// module chunks = 0